export const NIL_UUID = '00000000-0000-0000-0000-000000000000';
